import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { Proficiency, Skill } from '@core/tellent-skills-types';
import {
  DropdownHeaderComponent,
  DropdownItemComponent,
  IconButtonComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-proficiency-panel',
  templateUrl: './proficiency-panel.component.html',
  styleUrls: ['./proficiency-panel.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, DropdownHeaderComponent, DropdownItemComponent, IconButtonComponent],
})
export class ProficiencyPanelComponent {
  public readonly skill = input.required<Skill>();
  public readonly positionName = input.required<string>();
  public readonly showBackButton = input(false);

  public readonly proficiencySelected = output<Proficiency>();
  public readonly backClick = output<void>();

  protected onBack(event: Event): void {
    event.stopPropagation();
    this.backClick.emit();
  }
}
